import { QUERY_KEYS } from 'api/query-keys';
import { documentsService } from 'hq/services';
import { RawDocumentDetailData } from 'hq/services/documents-service.types';
import { useQuery } from 'react-query';

export const useDocumentDetail = (documentId: string) => {
  const queryFn = async () => await documentsService.getDocumentDetailById(documentId);

  return useQuery<RawDocumentDetailData, Error>(QUERY_KEYS.documentDetail(documentId), queryFn, {
    enabled: !!documentId,
  });
};
